import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text } from "../../components";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, use, useEffect } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
const ITEMS = [
  { key: "offers_new",     title: "הצעות שממתינות לאישור", color: "#CE0000", img: "/images/red-offer.svg" },
  { key: "offers_approved", title: "הצעות שאושרו",           color: "#619D1C", img: "/images/green-offer.svg" },
  { key: "offers_rejected", title: "הצעות שנדחו",            color: "#666666", img: "/images/gray-offer.svg" },
];


export default function MyOffersCountersDealer({ counters = {} }) {

  return (

    <div className="ads-counter-panel my-offers-counters-dealer flex w-[10%] flex-col gap-3 rounded-[24px] bg-secondary-primary_white p-6 shadow-xs md:w-full sm:p-4">
    <div className="flex justify-center">
      <Heading size="text2xl" as="h1" className="mt-1.5 !font-heebo text-[18px] font-medium lg:text-[15px]">
        ההצעות שלי 
      </Heading>
    </div>
    <div className="h-px bg-blue_gray-100" />
    <div className="ads-counter-panel-list mb-[244px] flex flex-col gap-3">
      <Suspense fallback={<div>Loading feed...</div>}>
      {ITEMS.map(it=>(
                  <UserProfile1 
                  key={it.key}
                myAd={{
                  number: counters[it.key] ?? 0,
                  title : it.title,
                  color : it.color,
                  img   : it.img,
                }}
          />
        ))}
      </Suspense>
    </div>
  </div>
  );
}
